import { render, staticRenderFns } from "./PayCodePayment.vue?vue&type=template&id=524da0a2&scoped=true&"
import script from "./PayCodePayment.vue?vue&type=script&lang=js&"
export * from "./PayCodePayment.vue?vue&type=script&lang=js&"
import style0 from "./PayCodePayment.vue?vue&type=style&index=0&id=524da0a2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524da0a2",
  null
  
)

export default component.exports